import { PersonData } from '@tymbe/schema/person.interface';
import { FavouriteIcon } from '@tymbe/ui-icons';
import { components, OptionProps, GroupBase, MenuProps, MultiValueProps, InputProps, ContainerProps, ControlProps, NoticeProps, MenuListProps } from 'react-select';

const { Option, Menu, Input, SelectContainer, Control, NoOptionsMessage, MenuList } = components;

export const InvitationSelectOption = <O extends PersonData, I extends boolean, G extends GroupBase<O>>(
  props: OptionProps<O, I, G>,
) => {
  const { label } = props;
  return (
    <Option {...props} className="!bg-transparent !p-0">
      <span>{label}</span>
    </Option>
  );
};

export const InvitationSelectControl = <O extends PersonData, I extends boolean, G extends GroupBase<O>>(
  props: ControlProps<O, I, G>,
) => {
  const { children } = props;
  return (
    <Control {...props} className='!min-h-0'>
      {children}
    </Control>
  );
};

export const InvitationSelectContainer = <O extends PersonData, I extends boolean, G extends GroupBase<O>>(
  props: ContainerProps<O, I, G>,
) => {
  const { children } = props;
  return (
    <SelectContainer {...props} className='!static w-full'>
      {children}
    </SelectContainer>
  );
};

export const InvitationSelectInput = <O extends PersonData, I extends boolean, G extends GroupBase<O>>(
  props: InputProps<O, I, G>,
) => {
  const { children } = props;
  return (
    <Input {...props} isHidden={false}>
      {children}
    </Input>
  );
};

export const InvitationSelectNoOptionsMessage = <O extends PersonData, I extends boolean, G extends GroupBase<O>>(
  props: NoticeProps<O, I, G>,
) => {
  const { children } = props;
  return (
    <NoOptionsMessage {...props}>
      {children}
    </NoOptionsMessage>
  );
};

export const InvitationSelectMenu = <O extends PersonData, I extends boolean, G extends GroupBase<O>>(
  props: MenuProps<O, I, G>,
) => {
  const { children, selectProps } = props;
  return (
    <Menu {...props} className="!rounded-lg !p-1 new-menu left-0 bg-white border-secondary-100 border-[1px] shadow-down-xs min-h-[47px] flex items-center justify-center !top-[100%]">
      <div onClick={selectProps.onMenuClose} className="cursor-pointer absolute z-10 right-1 top-1">
        <FavouriteIcon name='close' className="size-4" />
      </div>
      {children}
    </Menu>
  );
};

export const InvitationSelectMenuList = <O extends PersonData, I extends boolean, G extends GroupBase<O>>(
  props: MenuListProps<O, I, G>,
) => {
  const { children } = props;
  return (
    <MenuList {...props} className="w-full">
      {children}
    </MenuList>
  );
};

export const InvitationSelectMultiValue = <O extends PersonData, I extends boolean, G extends GroupBase<O>>(
  props: MultiValueProps<O, I, G>,
) => {
  const { data: { first_name, last_name }, removeProps } = props;
  return (
    <div className="flex flex-row items-center bg-base-back-3-transparent rounded-full px-2 py-1">
      <div className="text-xs font-geistMd">{first_name} {last_name}</div>
      <div onClick={removeProps.onClick}>
        <FavouriteIcon name='close' className="cursor-pointer ml-1 size-4" />
      </div>
    </div>
  );
};
